module.exports = __webpack_public_path__ + "img/crssoft-logo.35208db4.svg";